import { ModalBase, ModalStyle } from 'views/mutual/modal';
import { AgreementDocument } from '../index';
import { useAgreementDocumentModal } from './hooks';
import { AgreeDocumentModalProps } from 'views/pages/agreementDocument/modal/hooks';

type agreeDocumentProps = {
  onCompleted?: () => void;
}

export const AgreementDocumentModal = (props : agreeDocumentProps & AgreeDocumentModalProps) => {
  return (
    <ModalBase
      modalStyle={ModalStyle.InputConsentOnly}
      isOpen={props.isOpenAgreementModal ?? false}
      onRequestClose={(e) => {
        if (e.key === 'Escape') {
          e.preventDefault();
          return;
        }
        props.setIsOpenAgreementModal(false)
        props.onCompleted?.();
      }}
      children={
        <AgreementDocument
          agreementDocument={props.agreementDocument}
          onRequestClose={() => {
            props.setIsOpenAgreementModal(false);
            props.onCompleted?.();
          }}
        />
      }
      shouldCloseOnOverlayClick={false}
    />
  );
};
